import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "memberList",
  ref: "dialog"
};
var _hoisted_2 = {
  key: 0,
  "class": "memberList-title"
};
var _hoisted_3 = {
  "class": "title"
};
var _hoisted_4 = {
  "class": "memberList-box"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  "class": "memberList-box-body-name"
};
import TUIChatEngine, { TUIStore, StoreName, TUIGroupService, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, watch } from "../../../../adapter-vue";
import { isPC, isH5 } from "../../../../utils/env";
import { TUIGlobal } from "../../../../utils/universal-api/index";
import BottomPopup from "../../../common/BottomPopup/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["onAtListOpen", "insertAt"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var emits = __emit;
    var MessageInputAt = ref();
    var memberListItems = ref();
    var showAtList = ref(false);
    var memberList = ref();
    var allMemberList = ref();
    var showMemberList = ref();
    var isGroup = ref(false);
    var position = ref({
      left: 0,
      top: 0
    });
    var selectedIndex = ref(0);
    var _currentConversationID = ref("");
    var all = {
      userID: TUIChatEngine.TYPES.MSG_AT_ALL,
      nick: "所有人",
      isAll: true,
      avatar: "https://web.sdk.qcloud.com/im/assets/images/at.svg"
    };
    TUIStore.watch(StoreName.CONV, {
      currentConversationID: function currentConversationID(id) {
        if (id !== _currentConversationID.value) {
          var _currentConversationI;
          _currentConversationID.value = id;
          memberList.value = [];
          allMemberList.value = [];
          showMemberList.value = [];
          isGroup.value = false;
          TUIStore.update(StoreName.CUSTOM, "memberList", memberList.value);
          if (_currentConversationID !== null && _currentConversationID !== void 0 && (_currentConversationI = _currentConversationID.value) !== null && _currentConversationI !== void 0 && _currentConversationI.startsWith("GROUP")) {
            var _currentConversationI2;
            isGroup.value = true;
            var groupID = _currentConversationID === null || _currentConversationID === void 0 || (_currentConversationI2 = _currentConversationID.value) === null || _currentConversationI2 === void 0 ? void 0 : _currentConversationI2.substring(5);
            TUIGroupService.switchGroup(groupID);
          }
        }
      }
    });
    TUIStore.watch(StoreName.GRP, {
      currentGroupMemberList: function currentGroupMemberList(list) {
        memberList.value = list;
        allMemberList.value = [all].concat(_toConsumableArray(memberList.value));
        showMemberList.value = allMemberList.value;
        TUIStore.update(StoreName.CUSTOM, "memberList", memberList.value);
      }
    });
    var toggleAtList = function toggleAtList(show) {
      if (!isGroup.value) {
        return;
      }
      showAtList.value = show;
      if (showAtList.value) {
        emits("onAtListOpen");
      }
    };
    var handleAtListPosition = function handleAtListPosition(positionData) {
      position.value = positionData;
    };
    var setCurrentSelectIndex = function setCurrentSelectIndex(index) {
      var _memberListItems$valu;
      selectedIndex.value = index;
      memberListItems === null || memberListItems === void 0 || (_memberListItems$valu = memberListItems.value[selectedIndex.value]) === null || _memberListItems$valu === void 0 || _memberListItems$valu.scrollIntoView(false);
    };
    var setShowMemberList = function setShowMemberList(list) {
      showMemberList.value = list;
    };
    TUIGlobal.toggleAtList = toggleAtList;
    TUIGlobal.handleAtListPosition = handleAtListPosition;
    TUIGlobal.setCurrentSelectIndex = setCurrentSelectIndex;
    TUIGlobal.setShowMemberList = setShowMemberList;
    __expose({
      toggleAtList: toggleAtList
    });
    watch(function () {
      return [position.value, MessageInputAt === null || MessageInputAt === void 0 ? void 0 : MessageInputAt.value];
    }, function () {
      var _MessageInputAt$value;
      if (isH5 || !(MessageInputAt !== null && MessageInputAt !== void 0 && MessageInputAt.value) || !(MessageInputAt !== null && MessageInputAt !== void 0 && (_MessageInputAt$value = MessageInputAt.value) !== null && _MessageInputAt$value !== void 0 && _MessageInputAt$value.style)) {
        return;
      }
      MessageInputAt.value.style.left = position.value.left + "px";
      MessageInputAt.value.style.top = position.value.top - MessageInputAt.value.clientHeight + "px";
    });
    var closeAt = function closeAt() {
      showAtList.value = false;
      showMemberList.value = allMemberList.value;
      position.value = {
        left: 0,
        top: 0
      };
    };
    var selectItem = function selectItem(index) {
      if (isPC && TUIGlobal.selectItem) {
        TUIGlobal.selectItem(index);
      } else {
        var _showMemberList$value;
        if (showMemberList !== null && showMemberList !== void 0 && (_showMemberList$value = showMemberList.value) !== null && _showMemberList$value !== void 0 && _showMemberList$value.length) {
          var item = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value[index];
          emits("insertAt", {
            id: item === null || item === void 0 ? void 0 : item.userID,
            label: (item === null || item === void 0 ? void 0 : item.nick) || (item === null || item === void 0 ? void 0 : item.userID)
          });
        }
      }
      closeAt();
    };
    var handleMemberAvatar = function handleMemberAvatar(item) {
      return (item === null || item === void 0 ? void 0 : item.avatar) || "https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png";
    };
    var handleMemberName = function handleMemberName(item) {
      return item !== null && item !== void 0 && item.nick ? item === null || item === void 0 ? void 0 : item.nick : item === null || item === void 0 ? void 0 : item.userID;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(BottomPopup, {
        show: _unref(showAtList),
        onOnClose: closeAt
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": _normalizeClass([_unref(isPC) ? 'message-input-at' : 'message-input-at-h5']),
            ref_key: "MessageInputAt",
            ref: MessageInputAt
          }, [_createElementVNode("div", _hoisted_1, [!_unref(isPC) ? (_openBlock(), _createElementBlock("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_unref(TUITranslateService).t("TUIChat.选择提醒的人")), 1)])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showMemberList), function (item, index) {
            return _openBlock(), _createElementBlock("li", {
              "class": _normalizeClass(["memberList-box-body", [index === _unref(selectedIndex) && 'selected']]),
              key: index,
              onClick: function onClick($event) {
                return selectItem(index);
              },
              ref_for: true,
              ref_key: "memberListItems",
              ref: memberListItems
            }, [_createElementVNode("img", {
              "class": "memberList-box-body-avatar",
              src: handleMemberAvatar(item)
            }, null, 8, _hoisted_6), _createElementVNode("span", _hoisted_7, _toDisplayString(handleMemberName(item)), 1)], 10, _hoisted_5);
          }), 128))])], 512)], 2)];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
});